import React from 'react';
import TimePicker from 'react-time-picker';
import { Card, CardHeader, CardBody, FormGroup, Label } from 'reactstrap';
import { InputForm } from '../../../CustomForms';
import { DAY_TYPE_OPTIONS } from '../constants';
import SelectField from '../fields/SelectField';
import StartEndDatePicker from '../fields/StartEndDatePicker';

const toOptions = (items, keyPrefix) =>
  items.map((item) => ({
    key: `${keyPrefix}${item.id}`,
    value: item.id,
    name: item.name,
  }));

const dayTypeOptions = DAY_TYPE_OPTIONS.map((item) => ({
  key: `dayType${item.id}`,
  value: item.name.toLowerCase(),
  name: item.name,
}));

const PlaceTimeCard = ({
  fields,
  resources,
  eventCategoryCheck,
  trainingCampCategoryCheck,
  isInHotelTrainingSelected,
  onStudyMethodChange,
  handleSelect,
  handleInput,
  handleStartEndDate,
  handleStartTime,
  handleEndTime,
  handlePracticeStartTime,
  handlePracticeEndTime,
}) => {
  return (
    <Card className="my-4">
      <CardHeader>Tempat dan Waktu</CardHeader>
      <CardBody>
        <SelectField
          label="Metode Belajar"
          field={fields.study_methodId}
          options={toOptions(resources.studyMethods, 'studymethod')}
          placeholder="Pilih Metode Belajar"
          onChange={onStudyMethodChange}
        />
        <SelectField
          label="Jadwal Belajar"
          field={fields.study_scheduleId}
          options={toOptions(resources.studySchedules, 'studyschedule')}
          placeholder="Pilih Jadwal Belajar"
          onChange={(value) => handleSelect('study_scheduleId', value)}
        />
        <SelectField
          label="Branch"
          field={fields.branchId}
          options={toOptions(resources.branches, 'branch')}
          placeholder="Pilih Branch"
          onChange={(value) => handleSelect('branchId', value)}
        />
        {trainingCampCategoryCheck && (
          <SelectField
            label="Kota"
            field={fields.cityId}
            options={toOptions(resources.cities, 'city')}
            placeholder="Pilih Kota"
            onChange={(value) => handleSelect('cityId', value)}
          />
        )}
        {trainingCampCategoryCheck && isInHotelTrainingSelected && (
          <SelectField
            label="Venue"
            field={fields.venueId}
            options={toOptions(resources.venues, 'venue')}
            placeholder="Pilih Venue"
            onChange={(value) => handleSelect('venueId', value)}
          />
        )}
        <StartEndDatePicker
          handleStartEndDate={handleStartEndDate}
          startDate={fields.startDate.value}
          endDate={fields.endDate.value}
        />

        <SelectField
          label="Day Type"
          field={fields.dayType}
          options={dayTypeOptions}
          placeholder="Pilih Day Type"
          placeholderValue=""
          showHelp
          onChange={(value) => handleSelect('dayType', value)}
        />

        <InputForm
          {...fields.days}
          label="Training Session Days"
          onInput={(value) => handleInput('days', value)}
        />
        <FormGroup className="d-flex justify-content-around">
          <div className="w-100">
            <Label for="formStartDate" className="text-gray font-weight-bold">
              Training Session Start Time
            </Label>
            <div>
              <TimePicker
                onChange={handleStartTime}
                value={fields.startTime.value}
              />
            </div>
          </div>
          <div className="w-100">
            <Label for="formEndDate" className="text-gray font-weight-bold">
              Training Session End Time
            </Label>
            <div>
              <TimePicker
                onChange={handleEndTime}
                value={fields.endTime.value}
              />
            </div>
          </div>
        </FormGroup>
        <InputForm
          {...fields.practiceDays}
          label="Practice Session Days"
          onInput={(value) => handleInput('practiceDays', value)}
        />
        <FormGroup className="d-flex justify-content-around">
          <div className="w-100">
            <Label for="formStartDate" className="text-gray font-weight-bold">
              Practice Session Start Time
            </Label>
            <div>
              <TimePicker
                onChange={handlePracticeStartTime}
                value={fields.practiceStartTime.value}
              />
            </div>
          </div>
          <div className="w-100">
            <Label for="formEndDate" className="text-gray font-weight-bold">
              Practice Session End Time
            </Label>
            <div>
              <TimePicker
                onChange={handlePracticeEndTime}
                value={fields.practiceEndTime.value}
              />
            </div>
          </div>
        </FormGroup>
        {!eventCategoryCheck ? (
          <InputForm
            {...fields.code}
            label="Code"
            onInput={(value) => handleInput('code', value)}
          />
        ) : null}

        <InputForm
          {...fields.maxSeats}
          label="Max Seats"
          onInput={(value) => handleInput('maxSeats', value)}
          type="number"
        />
      </CardBody>
    </Card>
  );
};

export default PlaceTimeCard;
